import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { MobileNav } from "@/components/MobileNav";

const LOGO_URL = "/images/logo.png";

const LINKS = [
  { label: "Collection", id: "collection" },
  { label: "Story", id: "story" },
  { label: "Services", id: "services" },
  { label: "FAQ", id: "faq" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="navbar"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-6xl"
    >
      <div className="backdrop-blur-md bg-white/80 border border-stone-200/60 rounded-full px-5 sm:px-7 py-2 flex items-center justify-between shadow-[0_8px_30px_rgba(28,25,23,0.06)]">
        <button
          data-testid="nav-brand"
          onClick={() => go("top")}
          className="flex items-center"
        >
          <img src={LOGO_URL} alt="Faithfully Linked — a permanent jewelry company" className="h-16 w-auto object-contain" />
        </button>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[11px] font-mono uppercase tracking-[0.18em] text-stone-500 hover:text-ink transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-book-now-button"
            onClick={() => go("booking")}
            className="hidden sm:inline-flex rounded-full bg-ink text-alabaster text-xs font-medium tracking-wide px-5 py-2.5 hover:bg-gold transition-colors duration-300"
          >
            Book Appointment
          </button>
          <button
            data-testid="nav-menu-toggle"
            aria-label="Toggle menu"
            className="md:hidden text-ink"
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && <MobileNav links={LINKS} onNavigate={go} />}
    </header>
  );
}
